import { PortalAdminResource } from './portal-resource.model';

export const PORTAL_ADMIN_RESOURCES: PortalAdminResource[] = [
  {
    id: 'static-files',
    title: 'Dosyalar',
    description: 'Sistemdeki statik dosya ve ek kayıtlarını izleyin.',
    route: 'static-files',
    icon: 'draft',
    endpoint: 'attachment.getAllByStaticFile',
    method: 'GET',
    displayColumns: ['id', 'fileName', 'url', 'isActive'],
  },
  {
    id: 'properties',
    title: 'Ürün Özellikleri',
    description: 'Ürünlerde kullanılan ortak özellikleri yönetin.',
    route: 'properties',
    icon: 'tune',
    endpoint: 'property.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'PropertyFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'name', 'isActive'],
  },
  {
    id: 'users',
    title: 'Kullanıcılar',
    description: 'Sistem kullanıcılarını ve temel hesap bilgilerini görüntüleyin.',
    route: 'users',
    icon: 'groups',
    endpoint: 'user.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'UserFilterRequestDto',
    searchField: 'searchText',
    displayColumns: [
      'firstName',
      'lastName',
      'roleDescription',
      'organizationDescription',
      'branchDescription',
      'isActive',
    ],
    columnLabels: {
      firstName: 'Ad',
      lastName: 'Soyad',
      roleDescription: 'Rol',
      organizationDescription: 'Organizasyon',
      branchDescription: 'Şube',
      isActive: 'Aktif',
    },
    reusedFrom: '@dental-ui/users',
  },
  {
    id: 'products',
    title: 'Ürünler',
    description: 'Dental ürün katalog kayıtlarını listeleyin.',
    route: 'products',
    icon: 'inventory_2',
    endpoint: 'product.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'ProductFilterRequestDto',
    searchField: 'name',
    displayColumns: ['name', 'categoryDescription', 'isActive'],
    columnLabels: {
      name: 'Ad',
      categoryDescription: 'Kategori',
      isActive: 'Aktif',
    },
  },
  {
    id: 'categories',
    title: 'Kategoriler',
    description: 'Ürün kategori ağacını ve bağlı makine türlerini izleyin.',
    route: 'categories',
    icon: 'category',
    endpoint: 'category.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'CategoryFilterRequestDto',
    searchField: 'name',
    displayColumns: ['name', 'mainCategoryName', 'isActive'],
    columnLabels: {
      name: 'Ad',
      mainCategoryName: 'Ana Kategori',
      isActive: 'Aktif',
    },
  },
  {
    id: 'machine-models',
    title: 'Makine Modelleri',
    description: 'Makine model tanımlarını listeleyin.',
    route: 'machine-models',
    icon: 'precision_manufacturing',
    endpoint: 'machineModel.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'MachineModelFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'brandDescription', 'machineTypeDescription', 'isActive'],
  },
  {
    id: 'machine-types',
    title: 'Makine Türleri',
    description: 'Makine türü ana kayıtlarını yönetin.',
    route: 'machine-types',
    icon: 'settings_input_component',
    endpoint: 'machineType.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'MachineTypeFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'isActive'],
  },
  {
    id: 'brands',
    title: 'Makine Markaları',
    description: 'Makine marka kayıtlarını görüntüleyin.',
    route: 'brands',
    icon: 'sell',
    endpoint: 'brand.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'BrandFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'machineTypeDescription', 'isActive'],
  },
  {
    id: 'roles',
    title: 'Roller',
    description: 'Rol tanımlarını ve aktiflik durumlarını görüntüleyin.',
    route: 'roles',
    icon: 'admin_panel_settings',
    endpoint: 'role.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'RoleFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'isActive'],
    columnLabels: {
      description: 'Açıklama',
      isActive: 'Aktif',
    },
    reusedFrom: '@dental-ui/role',
  },
  {
    id: 'permissions',
    title: 'İzinler',
    description: 'Sistem izinlerini listeleyin.',
    route: 'permissions',
    icon: 'key',
    endpoint: 'permission.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'PermissionFilterRequestDto',
    searchField: 'description',
    displayColumns: ['description', 'isActive'],
    columnLabels: {
      description: 'Açıklama',
      isActive: 'Aktif',
    },
  },
  {
    id: 'packages',
    title: 'Paketler',
    description: 'Abonelik paketlerini yönetin.',
    route: 'packages',
    icon: 'deployed_code',
    endpoint: 'package.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'PackageFilterRequestDto',
    searchField: 'name',
    displayColumns: ['name', 'monthlyPrice', 'yearlyPrice', 'totalMonthlyPrice', 'totalYearlyPrice', 'isActive'],
  },
  {
    id: 'package-contents',
    title: 'Paket İçerikleri',
    description: 'Paketlerde kullanılabilen içerik tanımlarını yönetin.',
    route: 'package-contents',
    icon: 'fact_check',
    endpoint: 'feature.getAllByFilter',
    method: 'POST',
    filterBodyKey: 'FeatureFilterRequestDto',
    searchField: 'name',
    displayColumns: ['name', 'code', 'monthlyPrice', 'yearlyPrice', 'totalMonthlyPrice', 'totalYearlyPrice', 'isActive'],
  },
];

export function findPortalAdminResource(id: string | null): PortalAdminResource | undefined {
  return PORTAL_ADMIN_RESOURCES.find((resource) => resource.id === id || resource.route === id);
}
